/** True when the stored source language is English (en, en-US, eng, english). Unknown/empty is not English. */
export function isEnglishTranscriptLanguage(language: string | null | undefined): boolean {
  if (!language?.trim()) {
    return false;
  }
  const base = language.trim().toLowerCase().split(/[-_]/)[0];
  return base === 'en' || base === 'eng' || base === 'english';
}

/** Show Translated/Original tabs only when a real non-English original exists. */
export function hasDistinctTranslation(
  translated: string | null | undefined,
  original: string | null | undefined,
  language?: string | null
): boolean {
  const t = translated?.trim() ?? '';
  const o = original?.trim() ?? '';
  if (!t || !o) {
    return false;
  }
  if (isEnglishTranscriptLanguage(language)) {
    return false;
  }
  return t !== o;
}
